module.exports = __webpack_public_path__ + "static/img/introduceContent1.67f3d95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduceContent1.png
// module id = uSkT
// module chunks = 0